"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const messageUtils = __importStar(require("./messageUtils"));
const BaseMessage_1 = require("./BaseMessage");
const WarningMessageElement_1 = require("./internal/WarningMessageElement");
const utils_1 = require("../../internal/utils");
const DEEP_ORANGE_A100 = "#ff9e80";
class WarningMessage extends BaseMessage_1.BaseMessage {
    createMessageElementInternal() {
        return new WarningMessageElement_1.WarningMessageElement();
    }
    drawCellMessageInternal(_message, context, style, helper, grid, _info) {
        const { bgColor } = style;
        const { select } = context.getSelection();
        if (!utils_1.cellInRange(grid.getCellRange(context.col, context.row), select.col, select.row) ||
            !grid.hasFocusGrid()) {
            helper.drawBorderWithClip(context, (_ctx) => {
                messageUtils.drawExclamationMarkBox(context, {
                    bgColor: DEEP_ORANGE_A100,
                    color: bgColor,
                }, helper);
            });
        }
    }
}
exports.WarningMessage = WarningMessage;
